// extracted by mini-css-extract-plugin
export default {"home":"Home_home__sMFlT","home_icon":"Home_home_icon__SgYiw","home_text":"Home_home_text__spBEQ"};